import { makeStaticStyles, makeStyles, tokens } from "@fluentui/react-components";
import { ScrollBarBorderRadius, ScrollBarHeight, ScrollBarWidth } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
import { Colors } from "@ms/uno-constants/lib/local/Colors";
/**
 * Styles for the Planner shell layout using Fluent UI v9 makeStyles
 */ export const usePlannerShellLayoutStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: tokens.colorNeutralBackground1,
        maxHeight: "100vh",
        maxWidth: "100vw",
        inset: "0px",
        position: "fixed"
    },
    appContent: {
        display: "flex",
        flexDirection: "row",
        flex: "1 1 0px",
        minHeight: 0,
        minWidth: 0
    },
    mainContentContainer: {
        float: "none",
        overflow: "hidden",
        width: "100%",
        backgroundColor: tokens.colorNeutralBackground1,
        position: "relative",
        ...flexParent("column")
    }
});
/**
 * Global scrollbar styles applied to all elements
 * Uses makeStaticStyles for proper global scope
 */ export const useGlobalScrollbarStyles = makeStaticStyles({
    "*::-webkit-scrollbar": {
        width: ScrollBarWidth,
        height: ScrollBarHeight
    },
    "*::-webkit-scrollbar-track": {
        borderRadius: ScrollBarBorderRadius
    },
    "*::-webkit-scrollbar-track-piece": {
        borderRadius: ScrollBarBorderRadius
    },
    "*::-webkit-scrollbar-thumb": {
        backgroundColor: tokens.colorNeutralForeground4,
        borderRadius: ScrollBarBorderRadius
    }
});
/**
 * Static global styles for Fluent UI VerticalStackedBarChart tooltips
 * Needed because the tooltip is rendered outside of the React tree
 */ export const useTooltipGlobalStyles = makeStaticStyles({
    "div.fui-vsbc__tooltip": {
        backgroundColor: Colors.White,
        color: Colors.Grey14,
        padding: "4px 8px",
        borderRadius: "4px",
        border: `1px solid ${Colors.Grey82}`,
        fontSize: "12px",
        fontFamily: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"
    }
});
